import useCancelTokenSource from "../../hooks/useCancelTokenSource";
import TownAPIs from "../../APIs/TownAPIs";
import SearchBar from "./SearchBar";
import React, {useCallback} from "react";
import IAgence from "../../interfaces/IAgence";
import {REQUEST_CANCELED} from "../../helpers/Message";

interface AgencySearchBarProps {
    disabled: boolean,
    disableSearchButton: (v: boolean) => void,
    setAgency: (a: IAgence | null) => void
}

function AgencySearchBar({disabled, disableSearchButton, setAgency} : AgencySearchBarProps) {
    const { createSource, cancelPreviousRequest } = useCancelTokenSource({
        cancelMessage: REQUEST_CANCELED
    });

    const handleSelect = (agency: IAgence) => {
        disableSearchButton(false);
        setAgency(agency);
    }

    const fetchData = useCallback(async (query: string): Promise<IAgence[]> => {
        cancelPreviousRequest(REQUEST_CANCELED);

        if (query.length > 2) {
            const source = createSource();
            return TownAPIs.getInterkabAgencies({search: query}, source);
        }

        return [];
    }, [cancelPreviousRequest, createSource]);

    const format = useCallback((agency: IAgence) => ({
        value: agency,
        label: `${agency.nom}, ${agency.instanceName} (${agency.ville})`
    }), []);

    return (
        <SearchBar<IAgence>
            placeholder="Agence"
            name="agence"
            disabled={disabled}
            onSelect={handleSelect}
            onChange={() => disableSearchButton(true)}
            optionsProps={{
                format: format,
                fetchDataOnChange: fetchData
            }}
        />
    )
}

export default AgencySearchBar;
